var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSliderArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 54,
    viewBox: "0 0 29 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.18021e-06 27C1.15277e-06 27.6277 0.141736 28.2561 0.424848 28.7354L14.9248 53.2807C15.4914 54.2398 16.4089 54.2398 16.9751 53.2807C17.5413 52.3216 17.5417 50.7685 16.9751 49.81L3.50029 27L16.9751 4.19004C17.5417 3.23093 17.5417 1.67783 16.9751 0.719329C16.4085 -0.239163 15.491 -0.239777 14.9248 0.719329L0.424848 25.2646C0.141736 25.7439 1.20765e-06 26.3723 1.18021e-06 27ZM12.0248 25.2646L26.5248 0.71933C27.0914 -0.239777 28.0088 -0.239777 28.5751 0.71933C29.1413 1.67844 29.1416 3.23155 28.5751 4.19004L15.1003 27L28.5751 49.81C29.1416 50.7691 29.1416 52.3222 28.5751 53.2807C28.0085 54.2392 27.091 54.2398 26.5248 53.2807L12.0248 28.7354C11.7417 28.2561 11.6 27.6277 11.6 27C11.6 26.3723 11.7417 25.7439 12.0248 25.2646Z",
    fill: "#751034"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSliderArrow);
export default __webpack_public_path__ + "static/media/slider-arrow.65e044d54fa5d386b5cb712daa0e65d2.svg";
export { ForwardRef as ReactComponent };